module.exports = {"title":"핀 위치 통계","selectGolfClub":"골프클럽을 선택하세요.","month1":"1개월","month3":"3개월","month6":"6개월","tooltip":"검색한 기간의 통합 통계입니다.","selectType":"유형을 선택하세요."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/cr101.json
// module id = lDAO
// module chunks = 2